"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("table", {
    attrs: {
      id: "myTable"
    }
  }, [_c("tr", {
    staticClass: "pagebreak"
  }, [_c("td", [_c("div", {
    staticClass: "mainFlagQRCode"
  })])])]);
}];
render._withStripped = true;